import { JetView } from 'webix-jet'; // Importing JetView from the webix-jet library for creating views
import { allpayments } from 'models/allpayments'; // Importing allpayments model for data handling
import { devConfig } from 'config/config'; // Importing development configuration settings

/**
 * Class representing the table deposit report view.
 * @extends JetView
 */
export default class tableDepositReportView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        // Retrieve the localization service and its translation function
        const _ = this.app.getService('locale')._;
        // Format date according to the application's date format configuration
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        // Sample data array containing user information
        const data = [
            {
                Id: '01', // Unique identifier for the entry
                Name: 'Cedula', // Name of the user type
                Description: 'Cedula de ciudadania ', // Description of the user type
                Type: '0', // Type identifier
                User: '2356', // User ID
            },
        ];
        // Preserve the context of 'this' for use in nested functions
        var vthis = this;
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader element
                    cols: [
                        {
                            view: 'datatable', // Define a datatable view
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: screen.width < 500 ? 405 : 0, // Set height based on screen width
                            columns: [
                                {
                                    id: 'Id', // Column ID
                                    header: 'Id', // Column header
                                    width: 80, // Column width
                                    sort: 'int', // Enable integer sorting
                                },
                                {
                                    id: 'detailTittle', // Column ID for action buttons
                                    header: '', // No header for this column
                                    width: 60, // Column width
                                    height: 25, // Column height
                                    tooltip: _('Acción'), // Tooltip text for the column
                                    template: function (obj) {
                                        // Template function to render action icons
                                        return "<span class='webix_icon wxi-close details'></span><span class='webix_icon wxi-close edit'></span>";
                                    },
                                },
                                {
                                    id: 'Name', // Column ID for user name
                                    header: _('Nombre'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Enable integer sorting
                                },
                                {
                                    id: 'Description', // Column ID for description
                                    header: _('Descripción'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Enable integer sorting
                                },
                                {
                                    id: 'Type', // Column ID for user type
                                    header: _('Tipo Usuario'), // Column header with localization
                                    options: [
                                        // Options for user type dropdown
                                        { id: '0', value: _('Agente') }, // Option for 'Agent'
                                        { id: '1', value: _('Afiliador') }, // Option for 'Affiliate'
                                    ],
                                },
                                {
                                    id: 'User', // Column ID for user ID
                                    header: _('Usuario Id'), // Column header with localization
                                    width: 200, // Column width
                                    sort: 'int', // Enable integer sorting
                                },
                            ],
                            onClick: {
                                // Event handlers for click events on action icons
                                details: function (euv, id) {
                                    // Handler for details icon click
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent(
                                        // Trigger an event with the item ID
                                        'detailsRequirements:id',
                                        [item.Id],
                                    );
                                },
                                edit: function (euv, id) {
                                    // Handler for edit icon click
                                    $$('editRequirementsAgent').show(); // Show the edit dialog
                                },
                            },
                            tooltip: true, // Enable tooltips for the datatable
                            math: true, // Enable mathematical operations in the datatable
                            loadahead: devConfig.getDefaultDataFetch(), // Set data fetch configuration
                            pager: 'pagerA', // ID for the pager component
                            data: data, // Initial data for the datatable
                            // API endpoint for fetching data
                            url: devConfig.geturlApi() + 'es/GetRequirementsAgent',
                        },
                    ],
                },
            ],
        }; // Placeholder for the configuration content
    }

    /**
     * Initializes the view and its components.
     * @param {Object} grid - The grid component to be initialized.
     */
    init(grid) {
        // Retrieve the localization service from the app
        const _ = this.app.getService('locale')._;
        // Get the datatable component
        grid = $$('datatable');
        // Store the URL for data loading from the grid
        var url = grid.data.url;
        // Initialize an empty filter string
        var filter = '';
        // Preserve the context of 'this' for use in the event handler
        var vthis = this;
        // Listen for the 'requirementsAgent:filter' event
        this.on(this.app, 'requirementsAgent:filter', (filterData) => {
            // Convert filterData object into an array of entries
            var object = Object.entries(filterData);
            // Initialize an empty string to build the query parameters
            var string1 = '';
            // Iterate over each entry in the filterData
            for (var i = 0; i < object.length; i++) {
                // Check if the value is not an object and not empty
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Handle date range filtering
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        // Append dateFrom and dateTo to the query string
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        // Append other filter parameters to the query string
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    }
                } else {
                    // Handle case where the value is an object
                    if (typeof object[i][1] === 'object') {
                        // Convert the nested object into an array of entries
                        var object2 = Object.entries(object[i][1]);
                        // Iterate over each entry in the nested object
                        for (var j = 0; j < object2.length; j++) {
                            // Check if the value is not null
                            if (object2[j][1] !== null) {
                                // Handle start date
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    // Format the start date into a string
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    // Append the formatted start date to the query string
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    // Handle end date
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        // Format the end date into a string
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        // Append the formatted end date to the query string
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            // Clear all existing data in the grid
            grid.clearAll();
            // Load new data into the grid with the constructed URL and query parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            // Update the filter variable with the constructed query string
            filter = string1;
        });
        // Attach an event handler for the 'onAfterSort' event of the grid
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Load the grid data with sorting parameters
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });

        // Create a popup window for editing requirements
        var popup = webix.ui({
            view: 'window',
            width: 400,
            height: 400,
            id: 'editRequirementsAgent',
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label: _('Editar Requisito'), // Label for editing requirement
                        align: 'center',
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon for the window
                        click: function () {
                            // Hide the popup window when the icon is clicked
                            this.getTopParentView().hide();
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form',
                id: 'editform', // ID for the form
                elements: [
                    {
                        view: 'text',
                        label: 'Id:', // Label for the ID field
                        name: 'Id', // Name of the field
                        labelWidth: 120,
                        readonly: true, // Make the ID field read-only
                        labelWidth: 120,
                    },
                    {
                        view: 'text',
                        label: _('Nombre:'), // Label for the Name field
                        name: 'Name', // Name of the field
                        labelWidth: 120,
                        readonly: false, // Allow editing of the Name field
                        labelWidth: 120,
                    },
                    {
                        view: 'textarea',
                        label: _('Descripción:'), // Label for the Description field
                        name: 'Description', // Name of the field
                        labelWidth: 120,
                        readonly: false, // Allow editing of the Description field
                        labelWidth: 120,
                    },
                    {
                        view: 'combo',
                        label: _('Tipo Usuario:'), // Label for the User Type field
                        name: 'Type', // Name of the field
                        labelWidth: 120,
                        options: [
                            { id: '0', value: _('Agente') }, // Option for Agent
                            { id: '1', value: _('Afiliador') }, // Option for Affiliate
                        ],
                        labelWidth: 120,
                    },
                    {
                        view: 'text',
                        type: 'number',
                        label: _('Usuario Id:'), // Label for the User ID field
                        name: 'User', // Name of the field
                        labelWidth: 120,
                        readonly: true, // Make the User ID field read-only
                        labelWidth: 120,
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Cancelar'), // Label for the Cancel button
                                click: function () {
                                    // Hide the popup window when Cancel is clicked
                                    this.getTopParentView().hide();
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: _('Guardar'), // Label for the Save button
                                click: function ($e) {
                                    // Get values from the form
                                    var values = $$('editform').getValues();
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type for the request
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'RequirementsAgent/UpdateRequirements', // API endpoint for updating requirements
                                            '{"Id":' +
                                                values.Id +
                                                ',"Name":"' +
                                                values.Name +
                                                '","Description":"' +
                                                values.Description +
                                                '","Type":"' +
                                                values.Type +
                                                '","User":"' +
                                                values.User +
                                                '"}', // JSON payload for the request
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    // Show error message on failure
                                                    webix.message(_('Error! '));
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    // Show success message on successful update
                                                    webix.message(_('Requisito Editado'));
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload the grid data
                                                    );
                                                },
                                            },
                                        );
                                    this.getTopParentView().hide(); // Hide the popup window after saving
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Create a popup window for adding categories to a product
        var popupAdd = webix.ui({
            view: 'window', // Define the view type as a window
            width: 400, // Set the width of the window
            height: 400, // Set the height of the window
            id: 'AddCategoriesProduct', // Unique identifier for the window
            head: {
                view: 'toolbar', // Define a toolbar for the window header
                cols: [
                    {
                        view: 'label', // Label to display the title
                        label: _('Añadir Requisito'), // Title text
                        align: 'center', // Center align the label
                    },
                    {
                        view: 'icon', // Icon button for closing the window
                        icon: 'wxi-close', // Icon type
                        click: function () {
                            // Click event to hide the window
                            this.getTopParentView().hide(); // Hide the top parent view (the window)
                        },
                    },
                ],
            },
            position: 'center', // Center the window on the screen
            modal: true, // Make the window modal
            body: {
                view: 'form', // Define the body as a form
                id: 'addform', // Unique identifier for the form
                elements: [
                    {
                        view: 'text', // Text input for the name
                        label: _('Nombre:'), // Label for the input
                        name: 'Name', // Name attribute for the input
                        labelWidth: 120, // Width of the label
                    },
                    {
                        view: 'textarea', // Textarea for the description
                        label: _('Descripción:'), // Label for the textarea
                        name: 'Description', // Name attribute for the textarea
                        labelWidth: 120, // Width of the label
                    },
                    {
                        view: 'combo', // Combo box for user type selection
                        label: _('Tipo Usuario:'), // Label for the combo box
                        name: 'Type', // Name attribute for the combo box
                        options: [
                            // Options for the combo box
                            { id: '0', value: _('Agente') }, // Option for 'Agent'
                            { id: '1', value: _('Afiliador') }, // Option for 'Affiliate'
                        ],
                        labelWidth: 120, // Width of the label
                    },
                    {
                        view: 'text', // Text input for user ID
                        type: 'number', // Specify input type as number
                        label: _('Usuario Id:'), // Label for the input
                        name: 'User', // Name attribute for the input
                        labelWidth: 120, // Width of the label
                    },
                    {
                        cols: [
                            // Define a row of buttons
                            {
                                view: 'button', // Button for cancel action
                                value: _('Cancelar'), // Button text
                                click: function () {
                                    // Click event for the button
                                    this.getTopParentView().hide(); // Hide the top parent view (the window)
                                    $$('addform').setValues(
                                        // Reset the form values
                                        $$('addform').getCleanValues(), // Get clean values from the form
                                    );
                                },
                            },
                            {
                                view: 'button', // Button for adding the requirement
                                type: 'form', // Specify button type as form
                                value: _('Añadir'), // Button text
                                click: function ($e) {
                                    // Click event for the button
                                    var values = $$('addform').getValues(); // Get values from the form
                                    webix // Perform an AJAX request
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type to JSON
                                        })
                                        .post(
                                            devConfig.geturlApi() + // API endpoint for saving requirements
                                                'RequirementsAgent/SaveRequirements',
                                            '{"Name":"' + // Prepare JSON payload
                                                values.Name +
                                                '", "Description":"' +
                                                values.Description +
                                                '", "Type":"' +
                                                values.Type +
                                                '", "User":"' +
                                                values.User +
                                                '"}',
                                            {
                                                error: function (
                                                    // Error callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Error! ')); // Display error message
                                                },
                                                success: function (
                                                    // Success callback
                                                    text,
                                                    data,
                                                    XmlHttpRequest,
                                                ) {
                                                    webix.message(_('Requisito Agregado')); // Display success message
                                                    grid.clearAll(); // Clear the grid data
                                                    grid.load(
                                                        // Reload the grid with updated data
                                                        url + '?start=0&count=' + grid.data.$pagesize + filter,
                                                    );
                                                },
                                            },
                                        );
                                    $$('addform').setValues(
                                        // Reset the form values
                                        $$('addform').getCleanValues(), // Get clean values from the form
                                    );
                                    this.getTopParentView().hide(); // Hide the top parent view (the window)
                                },
                            },
                        ],
                    },
                ],
            },
        });
        // Listen for the 'addRequirements:button' event on the app instance
        // When the event is triggered, the popupAdd component is displayed
        this.on(this.app, 'addRequirements:button', (filter) => {
            popupAdd.show();
        });

        // Bind the 'editform' element to the 'datatable' element for data synchronization
        $$('editform').bind($$('datatable')); // Placeholder for the initialization content
    }
}

// FILE DOCUMENTED
